import React, { useEffect, useState } from 'react';
import { RiArrowLeftDoubleFill, RiArrowRightDoubleFill } from "react-icons/ri";
import axios from "axios";
import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setLoading(true);
        setError(null);
        
        console.log('Fetching banners from:', `${process.env.REACT_APP_API_URL}banner/get-all-banner`);
        
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/banner/get-all-banner`
        );

        console.log('API Response:', res.data);

        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
     
          const allImages = res.data.flatMap(banner => {
            if (banner.images && Array.isArray(banner.images)) {
              return banner.images;
            }
            return [];
          });
          
          console.log('Extracted images:', allImages);
          setImages(allImages);
        } else {
          console.log('No banner data found');
          setImages([]);
        }
      } catch (error) {
        console.error("Error fetching banners:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Auto slide
  useEffect(() => {
    if (images.length > 0) {
      const intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [images.length]); 

  
  if (loading) {
    return (
      <div className="relative w-full h-64 flex items-center justify-center bg-gray-200">
        <div className="text-gray-600">Loading banners...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="relative w-full h-64 flex items-center justify-center bg-red-100">
        <div className="text-red-600">Error loading banners: {error}</div>
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div className="relative w-full h-64 flex items-center justify-center bg-gray-100">
        <div className="text-gray-600">No banners available</div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-[600px] overflow-hidden">
    
      <div className="relative h-full">
        <div
          className="flex transition-transform duration-300 ease-in-out h-full"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((image, index) => (
            <div key={index} className="w-full flex-shrink-0 h-full">
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="h-full w-full object-cover object-center"
                onError={(e) => {
                  console.error(`Failed to load image: ${image}`);
                  e.target.style.display = 'none';
                }}
                onLoad={() => {
                  console.log(`Successfully loaded image: ${image}`);
                }}
              />
            </div>
          ))}
        </div>

      
        {images.length > 1 && (
          <>
          
            <button
              onClick={prevSlide}
              className="absolute top-1/2 left-2 transform -translate-y-1/2 focus:outline-none text-white hover:text-gray-300 transition-colors z-10 bg-black bg-opacity-30 rounded-full p-1 sm:p-2"
              aria-label="Previous slide"
            >
              <RiArrowLeftDoubleFill className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl" />
            </button>

            <button
              onClick={nextSlide}
              className="absolute top-1/2 right-2 transform -translate-y-1/2 focus:outline-none text-white hover:text-gray-300 transition-colors z-10 bg-black bg-opacity-30 rounded-full p-1 sm:p-2"
              aria-label="Next slide"
            >
              <RiArrowRightDoubleFill className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl" />
            </button>
          </>
        )}

        {images.length > 1 && (
          <div className="absolute bottom-2 sm:bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-colors ${
                  index === currentIndex 
                    ? 'bg-white' 
                    : 'bg-white bg-opacity-50'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeCarousel;